import { defineMessage } from "react-intl";
import type { FigureMetadata } from "../components/figure";

export const metadata: FigureMetadata = {
  id: "SECTOR_ALLOCABLE",
  title: defineMessage({
    id: "fig.finance.aid.SECTOR_ALLOCABLE.title",
    defaultMessage: ``,
  }),
  caption: defineMessage({
    id: "fig.finance.aid.SECTOR_ALLOCABLE.caption",
    defaultMessage: ``,
  }),
  source: defineMessage({
    id: "fig.finance.aid.SECTOR_ALLOCABLE.source",
    defaultMessage: ``,
  }),
};
